import { useContext, useEffect } from 'react'

import { translate } from 'utils/translations'

import AudioSearchSection from './audio-search-section'
import { AudioContentContext } from '../../context'
import { T } from 'consts/translationKeys'

export const MusicSearchSection: React.FC = () => {
  const { musicSearchValue, setMusicSearchValue, searchedMusicList } =
    useContext(AudioContentContext)

  useEffect(() => {
    return () => {
      setMusicSearchValue('')
    }
  }, [setMusicSearchValue])

  return (
    <AudioSearchSection
      placeholder={translate(T.SEARCH_MUSIC_LABEL)}
      searchValue={musicSearchValue}
      onChange={(value: string) => {
        setMusicSearchValue(value)
      }}
      searchResultList={searchedMusicList}
    />
  )
}
